module.exports = __webpack_public_path__ + "img/left.bc88797c.png";